import { HotelDetailImageViewModel, HotelPromotionViewModel } from '@api/index';
import { Amenity } from '@components/cards/amenity/AmenityCard';
import { Promotions } from '@components/cards/opportunity/OpportunityCard';
import { Images } from '@components/galleries/multiple-image/MultipleImageView';
import { FALLBACK_IMAGE_URL } from '@constants/constants';

export const formatAmenities = (amenities?: any): Amenity[] =>
  amenities?.map((amenity) => ({
    id: amenity.id,
    title: amenity.name || '',
    icon: amenity.featureIcon || '',
  })) || [];

export const formatHotelPromotions = (
  hotelPromotions?: HotelPromotionViewModel[]
): Promotions[] =>
  hotelPromotions?.map((item) => ({
    name: item.name || '',
    description: item.description || '',
    image: item.image || FALLBACK_IMAGE_URL,
  })) || [];

export const formatHotelImages = (
  images?: HotelDetailImageViewModel[],
  name?: string
): Images[] => {
  return (
    images?.map((image, index) => ({
      url: image?.url || FALLBACK_IMAGE_URL,
      alt: `${name} ${image?.hotelImageCategoryName} ${index + 1}`,
      providerId: image?.providerId,
      placeholderUrl: image?.placeholderUrl,
    })) || []
  );
};
